<template>
  <Intro />
  <JoinOurNetwork />
  <WhyChooseTHE />
  <HealthcareProf />
  <!--<OpenPositions />-->
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/workWithUs/WorkWithUsIntro.vue";
import JoinOurNetwork from "@/components/workWithUs/JoinOurNetwork.vue";
import HealthcareProf from "@/components/workWithUs/HealthcareProf.vue";
import WhyChooseTHE from "@/components/workWithUs/WhyChooseTHE.vue";
import OpenPositions from "@/components/workWithUs/OpenPositions.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

